import { Skeleton } from '@bp/ui-components';
import { BpPage } from 'components/BpPage/BpPage';
import { useAuthClaims } from 'hooks/useAuthClaims';
import { useTranslation } from 'react-i18next';

export function TemplatesPage() {
  const { t } = useTranslation();
  const { pimAuthClaims } = useAuthClaims();

  return (
    <BpPage title={t('templates.title')} isForbidden={false} organization={pimAuthClaims.getOrganization()}>
      <Skeleton />
    </BpPage>
  );
}
